export const WHATS_NEW_CAMPAIGN_ID = "sapaad-vantage-intro-nHWX7nFjICA";
export const WHATS_NEW_VIDEO_ID = "nHWX7nFjICA";
export const WHATS_NEW_MAX_VIEWS = 3;

const viewCountKey = (userId: number) =>
  `whats-new-views:${WHATS_NEW_CAMPAIGN_ID}:${userId}`;

const sessionKey = (userId: number) =>
  `whats-new-session:${WHATS_NEW_CAMPAIGN_ID}:${userId}`;

const readViewCount = (userId: number) => {
  const raw = window.localStorage.getItem(viewCountKey(userId));
  const count = Number(raw || "0");
  return Number.isFinite(count) ? count : 0;
};

/**
 * One view is one browser tab session. Returns true only the first time
 * this session is claimed, and stops after WHATS_NEW_MAX_VIEWS sessions.
 */
export const claimWhatsNewView = (userId: number): boolean => {
  try {
    if (window.sessionStorage.getItem(sessionKey(userId))) {
      return false;
    }

    const count = readViewCount(userId);
    if (count >= WHATS_NEW_MAX_VIEWS) {
      return false;
    }

    window.sessionStorage.setItem(sessionKey(userId), "1");
    window.localStorage.setItem(viewCountKey(userId), String(count + 1));
    return true;
  } catch (error) {
    console.error("Unable to persist What's new view count", error);
    return false;
  }
};
